<!-- ORCA-1945: no celular abre em tela cheia (altura real da tela): cabeçalho com Fechar e ações
     embaixo sempre visíveis; antes 100vh cortava os botões e o fechar. -->
<div class="oa-sheet preview-sheet">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>Visualização do orçamento</h2>
        <button type="button" class="oa-icon-btn" (click)="matDialogRef.close()" aria-label="Fechar visualização">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="preview-sheet__body">
        <div *ngIf="loading" class="preview-sheet__loading" role="status" aria-label="Carregando visualização">
            <mat-spinner color="primary" diameter="64"></mat-spinner>
        </div>

        <iframe src="about:blank" #contentIframe id="proposal-frame" title="Visualização do orçamento"
            [class.is-loading]="loading" frameborder="0"></iframe>
    </div>

    <!-- Botões do DS (ORCA-1919): Fechar ghost, Imprimir secondary, Gerar PDF primary -->
    <footer class="oa-sheet__footer preview-actions">
        <button type="button" (click)="matDialogRef.close()" class="oa-btn oa-btn--ghost preview-actions__close">
            Fechar
        </button>

        <button type="button" (click)="print()" class="oa-btn oa-btn--secondary">
            <mat-icon>print</mat-icon>
            <span>Imprimir</span>
        </button>

        <button *ngIf="data?.token" type="button" (click)="openPDF()" class="oa-btn oa-btn--primary">
            <mat-icon>picture_as_pdf</mat-icon>
            <span>Gerar PDF</span>
        </button>
    </footer>
</div>
